<template>
  <div class>
    <div class="md-layout-item md-size-100 md-medium-size-100">
      <div id="progress-bar-container" style="min-height:3px;">
        <template>
          <div
            v-if="loading"
            class="md-layout-item md-size-100 md-medium-size-100 bar-progress"
          >
            <md-progress-bar
              class="bar-progress"
              md-mode="indeterminate"
            ></md-progress-bar>
          </div>
        </template>
      </div>

      <md-card>
        <!-- <md-card-header>
          <h4 class="title">User's Audit</h4>
        </md-card-header>-->
        <md-card-content>
          <div v-if="audits.length > 0">
            <md-table v-model="searched">
              <md-table-toolbar>
                <div class="md-toolbar-section-start">
                  <h1 class="md-title">Logs</h1>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-20">
                    <div
                      class="md-layout-item md-small-size-100 md-size-100 md-xsmall-size-100"
                    >
                      <Autocomplete
                        label="User"
                        :options="users"
                        :val="zone"
                        @searchByUser="search_by_user"
                      />
                    </div>
                  </div>

                  <div class="md-layout-item md-size-25">
                    <md-field>
                      <md-input
                        v-model="search"
                        class="searchbox"
                        placeholder="Search..."
                        @input="searchOnTable"
                      />
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-25">
                    <md-field>
                      <md-input
                        v-model="search"
                        class="searchbox"
                        placeholder="Search..."
                        @input="searchOnTable"
                      />
                    </md-field>
                  </div>
                </div>
              </md-table-toolbar>

              <md-table-empty-state
                md-label="No logs found"
                :md-description="
                  `No logs found for this '${search}' query. Try a different search term.`
                "
              ></md-table-empty-state>
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="#">{{ item.id }}</md-table-cell>
                <md-table-cell md-label="User Name">{{
                  item.username
                }}</md-table-cell>
                <md-table-cell md-label="Event">{{ item.event }}</md-table-cell>
                <md-table-cell md-label="Date">{{
                  formatDate(item.created_at)
                }}</md-table-cell>
                <md-table-cell md-label="Auditable type">{{
                  item.auditable_type
                }}</md-table-cell>
                <md-table-cell md-label="Auditable id">{{
                  item.auditable_id
                }}</md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </md-card-content>
      </md-card>
      <template>
        <pagination
          v-model="pagination"
          type="info"
          :page-count="30"
        ></pagination>
      </template>
    </div>
  </div>
</template>

<script>
const toLower = text => {
  return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
  if (term) {
    console.log({ items })
    return items.filter(item => toLower(item.username).includes(toLower(term)))
  }

  return items
}

import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment-timezone'
import Autocomplete from './../../../components/Autocomplete'
import { Pagination } from '@/components'
export default {
  name: 'Audits',
  components: {
    Pagination
  },
  data() {
    return {
      search: null,
      searched: [],
      pagination: 1,
      loading: false,
      audits: []
    }
  },
  created() {
    this.loadAudits()
    this.LoadUsers()
  },
  methods: {
    async LoadUsers() {
      this.loading = true
    },
    loadAudits() {
      this.loading = true
      let url = process.env.VUE_APP_API_URL + '/systemlog/index'
      axios
        .get(url, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + this.$store.state.token
          }
        })
        .then(response => {
          this.audits = response.data.logs
          this.loading = false
          this.searched = this.audits
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    searchOnTable() {
      console.log({ audits: this.audits })
      console.log({ audits: this.search })
      this.searched = searchByName(this.audits, this.search)
    },
    formatDate(date) {
      let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      let utc_date = moment.tz(date, 'UTC')
      return utc_date
        .clone()
        .tz(timezone)
        .format('lll')
    }
  }
}
</script>

<style scoped>
.md-card {
  margin: 0 !important;
}
.searchbox {
  margin: 0 5px 0 5px;
}
</style>
